import React, { useRef, useState, useEffect } from 'react';
import './CheckboxListInput.css';
import validate from '../../common/validate';
import logComponent from '../../common/logComponent';
import CheckboxGroup from '../CheckboxGroup/CheckboxGroup';

export default function CheckboxListInput({ initialValues, label, name, showError, errorMessage, rules, onValidate, items, onSelect }) {
  if (logComponent('CheckboxListInput')) { console.debug('CheckboxListInput rendered'); }

  const [values, setValues] = useState([...initialValues]);
  const [validationDetails, setValidationDetails] = useState(null);
  const [isValid, setIsValid] = useState(null);
  const [needsValidation, setNeedsValidation] = useState(false);
  const valuesRef = useRef([...initialValues]);
  const isValidating = useRef(false);
  const [mostRecentReset, setMostRecentReset] = useState(Date.now());

  const setValuesRef = (el) => {
    if (logComponent('CheckboxListInput')) { console.debug('CheckboxListInput setValuesRef'); }
    setValues(el);
    valuesRef.current = el;
  }

  if (logComponent('CheckboxListInput')) { console.debug('CheckboxListInput rendered'); }

  useEffect(() => {
    if (logComponent('CheckboxListInput')) { console.debug('CheckboxListInput onMount'); }
    setNeedsValidation(true);
    
  }, [])


  useEffect(() => {
    if (logComponent('CheckboxListInput')) { console.debug('CheckboxListInput useEffect [showError]'); }
    if (isValidating) return;
    if (showError) validateThis();
  }, [showError])

  useEffect(() => {
    if (logComponent('CheckboxListInput')) { console.debug('CheckboxListInput useEffect [needsValidation]'); }
    if (isValidating) return;
    if (needsValidation === true) {
      validateThis();
      setNeedsValidation(false);
    }
  }, [needsValidation])

  const updateValues = (e) => {
    if (logComponent('CheckboxListInput')) { console.debug('CheckboxListInput updateValues'); }

    var newValues = e.criteria.map(item => item.acceptedValues.map(value => value));
    console.log('{ newValues: ' + JSON.stringify(e) + '}')

    setValuesRef(newValues);
    validateThis();


    if (onSelect) {
      onSelect(newValues);
    }

  }

  const validateThis = () => {
    if (logComponent('CheckboxListInput')) { console.debug('CheckboxListInput validateThis'); }
    console.log('{ isValidating.current: ' + isValidating.current + '}')
    if (isValidating.current) return;
    isValidating.current = true;

    let validationDetailsThis = [];
    for (let rule in rules) {

      validationDetailsThis.push({
        rule: rule,
        valid: validate[rule](valuesRef.current, rules[rule])
      })
    }

    let isValidThis = validationDetailsThis.reduce((prev, curr) => prev && curr.valid, true);

    setValidationDetails(validationDetailsThis);
    setIsValid(isValidThis);

    onValidate({
      name: name,
      isValid: isValidThis,
      values: valuesRef.current
    });
    isValidating.current = false;
  }
   
  return (
    <div className="Checkbox-List-Input">    
      {
        showError && !isValid &&
        <p className="Checkbox-List-Input__error">{errorMessage}</p>
      }
    <label
      className="Checkbox-List-Input__label"
      htmlFor={name + '-input'}>
      {label}{
        rules && rules.required &&
        <span className="Checkbox-List-Input__required"> *</span>
      }
    </label>
      <CheckboxGroup
        onChange={updateValues}
        name={name}
        initialSelections={initialValues}
        options={items}
        horizontal={true}
        reset={mostRecentReset} 
        includeInitialSelectionsOnInitialOnChange={ true }
      />
    </div>
  );
}
    
